import Topbar from "@/components/layout/Topbar";
import VehiculosTab from "@/components/rec/VehiculosTab";

export default function VehiculosPage() {
  return (
    <>
      <Topbar
        title="Vehículos"
        subtitle="Padrón de vehículos utilizados en el traslado de mercadería cárnica."
      />
      <div className="p-4" data-testid="vehiculos-page">
        <VehiculosTab />
      </div>
    </>
  );
}
